<template>
  <div class="mx-2">
    <div class="row">
      <div class="col-12">
        <label class="data-name mb-0">Especialista(s) de Servicio:</label>
        <div v-for="(specialist, key) in serviceSpecialists" :key="key">
          <div class="row bg-white mx-0 mt-2 rounded">
            <div class="col-12 col-md-4 my-4">
              <div class="color-secondary-6 font-14">
                Especialista de Servicio:
              </div>
              <span class="color-black font-16 font-weight-bold">
                {{ specialist?.fullName }}
              </span>
            </div>
            <div class="col-12 col-md-4 my-4">
              <div class="color-secondary-6 font-14">
                Número de Licencia:
              </div>
              <span class="color-black font-16">
                {{ specialist?.licenceNo | empty }}
              </span>
            </div>
            <div class="col-12 col-md-4 my-4">
              <div class="color-secondary-6 font-14">
                Fecha de Expiración:
              </div>
              <span class="color-black font-16">
                {{ specialist?.expirationDate | date }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            id="writerSpecialist"
            v-model="selectedWriterSpecialist"
            :disabled="readOnly"
            :error="errors[0]"
            fieldkey="id"
            fieldname="displayName"
            label="Persona que redactó el plan:"
            name="writerSpecialist"
            :options="writerSpecialists"
          />
        </validation-provider>
      </div>
    </div>

    <div v-if="!readOnly" class="col-12 mt-3 pr-0 d-flex justify-content-end">
      <action-button
        i="fa fa-save"
        text="Guardar"
        variant="success"
        @click="saveHandler"
      />
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';

export default {
  name: 'SpecialistSection',
  components: {
    CustomDropDown,
    ActionButton,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
    writerSpecialist: {
      type: Object,
      default: () => {},
    },
    serviceSpecialists: {
      type: Array,
      default: () => [],
    },
    writerSpecialists: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedWriterSpecialist: {
      get() {
        return this.writerSpecialist;
      },
      set(value) {
        this.$emit('update:writerSpecialist', value);
      },
    },
  },
  methods: {
    saveHandler() {
      this.$emit('save');
    },
  },
};
</script>
